// extracted by mini-css-extract-plugin
var _1 = "NB5bq";
var _2 = "iBeS4";
export { _1 as "c", _2 as "pause" }
